/** The review step piece, standard look over its behavior half. */
import { ReviewStepView } from './ReviewStepView';
import { useReviewStep, type ReviewStepInput } from './useReviewStep';

export function ReviewStep(props: ReviewStepInput) {
  return <ReviewStepView {...useReviewStep(props)} />;
}
